import React from 'react';

import clsx from 'clsx';

import * as classes from './BobLoadingMask.module.css';

const BobLoadingMask = ({
    className,
    override,
    ...props
}) => {

    return (
        <div className={clsx(classes.Mask, override)}>
            <div className={clsx(classes.IconContainer, className)}>
                <img src="/assets/images/BobLoaderLarge.gif" alt="loader" />
            </div>
            <div className={classes.Color} />
        </div>
    );
};

export default BobLoadingMask;
